<template>
  <div>
    <!-- <v-card>
      <v-card-text> -->
        <v-row v-if="activeModalityId && kind == 'concluded'" class="ma-0 px-3 pt-3">
          <v-col cols="12" class="pa-0">
            <filter-data
              with_client_portfolios
              :months_after="2"
              with_text_search
              text_search_label="Pesquisar"
              @doneFilter="handleDoneFilter"
            />
          </v-col>
        </v-row>
        <v-data-table
          :headers="computed_headers"
          :items="loading ? [] : items"
          class="elevation-0"
          :search="resolvedSearch"
          :loading="activeModalityId ? loading : false"
          ref="table"
          mobile-breakpoint="1"
        >
          <template v-slot:top>
            <v-row v-if="kind != 'concluded' && tableSearch == null" class="ma-0 pa-0" justify="center">
              <v-col cols="12" class="pa-0">
                <v-text-field label="Pesquisar" v-model="search" prepend-icon="mdi-magnify"></v-text-field>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols='5'>
                <v-card style="border-radius:12px" class="py-2">
                  <v-card-text class="px-2 py-1">
                    <v-row align="center" class="px-5" justify="center">
                      <v-icon class="mr-5" color='blue-grey darken-3'>mdi-currency-usd</v-icon>
                      <span class="title">{{ total_value_sum.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols='5'>
                <v-card style="border-radius:12px" class="py-2">
                  <v-card-text class="px-2 py-1">
                    <v-row align="center" class="px-5" justify="center">
                      <v-icon class="mr-5" color='blue-grey darken-3'>mdi-exit-to-app</v-icon>
                      <span class="title">{{ total_checks }} retornados</span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.attributes.value="{item}">
            {{ item.attributes.value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}
          </template>

          <template v-slot:item.attributes.created_at="{item}">
            {{ $moment(item.attributes.created_at.substring(0,10)).format('DD/MM/YYYY, h:mm') }}
          </template>

          <template v-slot:item.attributes.number="{item}">
            <v-row>
              <v-btn v-if="item.attributes.status != 'concluded' && cannot_edit" color="primary" icon small @click="showNumberMotive(item.attributes)"><v-icon small>mdi-pencil</v-icon></v-btn>
              {{ item.attributes.number }}
            </v-row>
          </template>

          <template v-slot:item.attributes.motive="{item}">
            <v-row>
              <v-btn v-if="item.attributes.status != 'concluded' && cannot_edit" color="primary" icon small @click="showNumberMotive(item.attributes)"><v-icon small>mdi-pencil</v-icon></v-btn>
              {{ item.attributes.motive }}
            </v-row>
          </template>

          <template v-slot:item.attributes.concluded_at="{item}">
            {{ $moment(item.attributes.created_at.substring(0,10)).format('DD/MM/YYYY, h:mm') }}
          </template>

          <template v-slot:item.attributes.comment="{item}">
            <v-btn :color="item.attributes.comment? 'primary' : ''" @click="showComment(item.attributes)" icon><v-icon>mdi-comment-processing-outline</v-icon></v-btn>
          </template>

          <template v-slot:item.attributes.place_name="{item}">
            {{item.attributes.place_name}}
          </template>


          <template v-slot:item.attributes.status="{item}">
            <v-chip outlined small color='success' class="ma-1">
              <v-avatar left>
                <v-icon small>{{status_map[item.attributes.status].icon}}</v-icon>
              </v-avatar>
              <b>{{status_map[item.attributes.status].text}}</b>
            </v-chip>
            <v-chip v-if="item.attributes.status == 'in_hands' &&  item.attributes.vrt_transaction_id" outlined small color='primary' class="ma-1">
              <v-avatar left>
                <v-icon small>mdi-credit-card-outline</v-icon>
              </v-avatar>
              <b>Fatura gerada</b>
            </v-chip>
          </template>

          <template v-slot:item.details="{item}">
            <dialog-returned-details :check="item.attributes"></dialog-returned-details>
          </template>


          <template v-slot:item.attributes.kind="{item}">
            <v-btn v-if="item.attributes.deposit_id || item.attributes.kind == 'Deposit'" color="purple" dark small rounded><v-icon left>mdi-file-document</v-icon>Depósito</v-btn>
            <v-btn v-if="item.attributes.check_id || item.attributes.kind == 'Check'" color="primary" dark small rounded><v-icon left>mdi-card-bulleted-outline</v-icon>Cheque</v-btn>
            <v-btn v-if="(!item.attributes.deposit_id && !item.attributes.check_id) || item.attributes.kind == 'Manual'" color="success" dark small rounded><v-icon left>mdi-plus-circle</v-icon>Manual</v-btn>
          </template>

          <template v-slot:item.actions="{item}">
            <!-- <v-btn color="success" fab small @click="actOnItem(item)"><v-icon>mdi-cash-check</v-icon></v-btn> -->

            <v-row justify='start' align='center' class="pa-3" v-if="kind == 'to_confirm'">
                <v-tooltip top color="black" v-if="can_edit">
                  <template v-slot:activator="{on}">
                    <span v-on="on">
                      <dialog-edit-returned :kind="kind" :check="item.attributes" @doneUpdate='handleDoneUpdate'></dialog-edit-returned>
                    </span>
                  </template>
                  Editar
                </v-tooltip>

              <dialog-confirm-returned v-if="canActOn('confirm')" :check="item.attributes" @confirmed="handleConfirmed"></dialog-confirm-returned>


              <v-tooltip top color="black" v-if="canActOn('delete')">
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" icon text color="error" class='ma-1' small :disabled="loading" @click="deleteCheck(item.attributes)"><v-icon>mdi-delete</v-icon></v-btn>
                </template>
                Excluir
              </v-tooltip>
            </v-row>

            <div class="d-flex justify-start align-center flex-wrap" v-if="kind == 'in_hands'">
              <v-tooltip top color="black" v-if="can_edit">
                <template v-slot:activator="{on}">
                  <!-- <dialog-edit-returned v-on="on" :kind="kind" :check="item" @doneUpdate='handleDoneUpdate'></dialog-edit-returned> -->
                </template>
                Editar
              </v-tooltip>

              <v-tooltip top color="black" v-if="['in_hands', 'payed', 'sent'].includes(item?.attributes?.status)">
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" icon text color="amber" class='ma-1' small :disabled="loading" @click="checkBackStatus(item.attributes)"><v-icon>mdi-undo</v-icon></v-btn>
                </template>
                Voltar
              </v-tooltip>

              <v-tooltip top color="black" v-if="item.attributes.status == 'confirmed' && canActOn('in_hand')">
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" icon text color="primary" class='ma-1' small :disabled="loading" @click="checkStatus(item.attributes, 'in_hands')"><v-icon>mdi-account-cash-outline</v-icon></v-btn>
                </template>
                Em mãos
              </v-tooltip>

              <v-tooltip top color="black" v-if="item.attributes.status == 'in_hands' && canActOn('pay') && !item.attributes.vrt_transaction_id">
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" icon text color="primary" class='ma-1' small :disabled="loading " @click="checkStatus(item.attributes, 'payed')"><v-icon>mdi-cash-check</v-icon></v-btn>
                </template>
                Pagar cheque
              </v-tooltip>

              <v-tooltip top color="black" v-if="item.attributes.status == 'in_hands' &&  item.attributes.vrt_transaction_id">
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" icon text color="primary" class='ma-1' small :disabled="loading "><v-icon>mdi-information-outline</v-icon></v-btn>
                </template>
                Esperando o pagamento da fatura
              </v-tooltip>

              <v-tooltip top color="black" v-if="item.attributes.status == 'payed' && canActOn('send') && !item.attributes.vrt_transaction_id">
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" icon text color="primary" class='ma-1' small :disabled="loading" @click="checkStatus(item.attributes, 'sent')"><v-icon>mdi-send</v-icon></v-btn>
                </template>
                Enviar
              </v-tooltip>
              <v-tooltip top color="black" v-if="item.attributes.status == 'sent' && canActOn('conclude') && !item.attributes.vrt_transaction_id">
                <template v-slot:activator="{on}">
                  <v-btn v-on="on" icon text color="success" class='ma-1' small :disabled="loading" @click="checkStatus(item.attributes, 'concluded')"><v-icon>mdi-check-all</v-icon></v-btn>
                </template>
                Concluir
              </v-tooltip>
            </div>
          </template>
        </v-data-table>

    <comment-dialog :check="returned_check" @doneUpdate="handleDoneUpdate" @closeComment="handleCloseComment" :comment_dialog="comment_dialog" :cannot_edit="cannot_edit"></comment-dialog>
    <number-motive-dialog :check="returned_check" @doneUpdate="handleDoneUpdate" @closeNumberMotive="handleCloseNumberMotive" :number_motive_dialog="number_motive_dialog"></number-motive-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import SolutionMap from '@/_backoffice/_registrations/mixins/solution_map.js'
import Api from '@/api/index';
import FilterData from '@/components/shared/FilterData.vue'

export default {
  name: 'ReturnedChecksTable',
  mixins: [SolutionMap],
  props: {
    payReturnedCheck: {
      type: Function,
    },
    items: {
      type: Array
    },
    headers: {
      type: Array,
      default: []
    },
    title: {
      type: String
    },
    with_date_search: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    kind: {
      type: String,
      default: 'to_confirm'
    },
    tableSearch: {
      type: String,
      default: null
    }
  },
  components: {
    FilterData,
    CommentDialog: () => import('./CommentDialog'),
    NumberMotiveDialog: () => import('./NumberMotiveDialog'),
    DialogReturnedDetails: () => import('./DialogReturnedDetails.vue'),
    DialogConfirmReturned: () => import('./DialogConfirmReturned.vue'),
    DialogEditReturned: () => import('./DialogEditReturned.vue'),
  },
  data() {
    return {
      role_action_map: {
        Director:       ['edit', 'confirm', 'delete', 'in_hand', 'pay', 'send', 'conclude'],
        SalesExecutive: ['in_hand', 'pay', 'send', 'conclude'],
        Manager:        ['in_hand', 'pay', 'send', 'conclude'],
        Financial:      ['in_hand', 'pay', 'send', 'conclude'],
        CreditAnalyst:  []
    },

      search: '',
      comment_dialog: false,
      number_motive_dialog: false,
      returned_check: {},
      loading_one_returned_check: false,
      status_map: {
        confirmed: {
          icon: 'mdi-check',
          text: 'Validado',
        },
        in_hands: {
          icon: 'mdi-account-cash-outline',
          text: 'Em mãos',
        },
        payed: {
          icon: 'mdi-cash-check',
          text: 'Pago',
        },
        sent: {
          icon: 'mdi-send',
          text: 'Enviado',
        },
        concluded: {
          icon: '',
          text: 'Concluído'
        },
        to_confirm: {
          icon: '',
          text: 'A confirmar'
        }
      },

      clients: [],
      selected_clients: []
    }
  },
  computed: {
    resolvedSearch() {
      return this.tableSearch != null ? this.tableSearch : this.search
    },
    total_value_sum() {
      if (this.$refs.table && this.resolvedSearch) {
        return this.$refs.table.internalCurrentItems.reduce((acc, one) => acc + Number(one.attributes.value), 0)
      }
      return this.items.reduce((acc, one) => acc + Number(one.attributes.value), 0)
    },
    total_checks() {
      if (this.$refs.table && this.resolvedSearch) {
        return this.$refs.table.internalCurrentItems.length
      }
      return this.items.length
    },
    can_edit(){
      let can = false
      if (this.kind == 'to_confirm'){
        can = this.has_roles(['Director'])
      } else if (this.kind == 'in_hands'){
        can =  this.has_roles(['SalesExecutive', 'Director', 'Manager', 'Financial'])
      }
      return can
    },
    cannot_edit(){
      return !this.isCreditAnalyst()
    },
    computed_headers(){
      if(this.has_roles(['SalesExecutive', 'Director', 'Manager', 'Financial'])){
        return this.headers
      }else{
        let headers = JSON.parse(JSON.stringify([...this.headers]))
        return headers.filter(el => {return el.value != 'actions' })
      }
    },
    ...mapState({
      allReturnedChecks: state => state.ReturnedCheck.allReturnedChecks,
    }),
  },
  methods: {
    handleDoneFilter(e){
      const q = e && e.query != null ? String(e.query).trim() : ''
      this.search = q
      this.$emit('doneFilter', { ...e })
    },
    getClients() {
      if(this.clients.length == 0 && this.kind == 'concluded'){
        Api.Client.index({ short: true }).then(r => r.data).then(d => {
          d = d.data ? d.data.map(c => c.attributes) : d
          this.clients = [{ name: 'TODOS', id: null }, ...d]
        })
      }
    },
    deleteCheck(check){
      let c = confirm('Deseja realmente apagar esse registro?')
      if (c){
        this.loading = true

        Api.ReturnedCheck.delete(check.id).then(r=> r.data).then(d=>{
          this.$emit('doneDelete')
        }).catch((err) => {
          console.log({err});
        }).finally(()=>{
          this.loading = false
        })
      }
    },
    canActOn(action){
      return this.role_action_map[this.current_user_role_name].includes(action)
    },
    actOnItem(item){
      this.payReturnedCheck(item)
    },
    showNumberMotive(item) {
      this.loading_one_returned_check = true
      this.number_motive_dialog = true
      this.returned_check = null
      this.returned_check = {...item}
      this.loading_one_returned_check = false
    },
    showComment(item) {
      this.loading_one_returned_check = true
      this.comment_dialog = true
      this.returned_check = null
      this.returned_check = {...item}
      this.loading_one_returned_check = false
    },
    handleCloseComment() {
      this.comment_dialog = false
      this.returned_check = null
    },
    handleCloseNumberMotive() {
      this.number_motive_dialog = false
      this.returned_check = null
    },
    handleDateSearch(e){
      this.$emit('dateSearched', e)
    },
    handleDoneUpdate(e){
      this.setCheck({check: {...e}})
      this.handleCloseComment()
      this.handleCloseNumberMotive()
      this.$emit('doneUpdate')
    },
    checkBackStatus(check){
      const statuses = {
        in_hands: 'confirmed',
        payed: 'in_hands',
        sent: 'payed',
      }
      this.checkStatus(check, statuses[check.status])
    },
    checkStatus(check, to_status){
      let c = confirm('Deseja realizar essa ação?')

      if (c){
        let obj = {id: check.id, status: to_status}
        if (to_status == 'concluded'){
          obj.concluded_by = this.current_user_employee_name
        }

        this.loading = true
        Api.ReturnedCheck.update(obj).then(r=> r.data).then(d=> {
          this.$emit('doneStatus')
        }).catch((err) => {
          console.log({err});
        }).finally(()=>{
          this.loading = false
        })
      }
      
    },
    handleConfirmed(){
      this.$emit('doneStatus')
    },
    ...mapMutations({
      setCheck: 'ReturnedCheck/updateOneReturnedCheck',
    })
  },
  watch: {
    activeModalityId(nv, ov){
      if(nv && nv != ov && this.clients.length > 0){
        this.getClients();
      }
    },
    selected_clients(nv){
      if(nv){
        this.$emit('clientSelected')
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
